<template>
    <div
        :class="[
            'cz2__panel',
            'cz2__panel--secondary',
            'cz2__design-side'
        ]">
        <div>
            <button class="back-button" :aria-label="$t('MENU_BACK')" @click.prevent="cancel"></button>

            <div class="pt-16 p-8 flex-1">
                <panel-header :title="`${$t('DESIGN_SIDE')} &mdash; ${selectedDesignSideDescription}`" />
                <div class="cz2__menu__items">
                    <menu-item
                        :title="$t('DESIGN_SIDE_FRONT')" type="side-front"
                        :selected="selectedDesignSide === 'front'"
                        :hasIndicator="false" @selected="selectSide('front')"></menu-item>

                    <menu-item
                        :title="$t('DESIGN_SIDE_BACK')" type="side-back"
                        :selected="selectedDesignSide === 'back'"
                        :hasIndicator="false" @selected="selectSide('back')"></menu-item>

                    <menu-item
                        :title="$t('DESIGN_SIDE_FRONTBACK')" type="side-front-back"
                        :selected="selectedDesignSide === 'front-back'" :hasIndicator="false"
                        @selected="selectSide('front-back')"></menu-item>

                    <menu-item
                        :title="$t('DESIGN_SIDE_BOTH')" type="side-both"
                        :selected="selectedDesignSide === 'both'"
                        :hasIndicator="false" @selected="selectSide('both')"></menu-item>
                </div>
            </div>

            <div
                class="panel-actions-height flex justify-center items-stretch p-2 lg:p-4 lg:border-t cz2__colors__actions--save-panel">
                <button
                    class="panel-actions-button-height flex text-center transition-opacity duration-200 text-lg bg-white text-black border border-black"
                    @click.prevent="cancel"><span>{{ $t('ACTION_CANCEL') }}</span></button>
                <button
                    class="panel-actions-button-height flex text-center transition-opacity duration-200 text-lg bg-blue-500 text-white"
                    @click.prevent="accept"><span>{{ $t('ACTION_SAVE') }}</span></button>
            </div>
        </div>
    </div>
</template>

<script>
    import { fillEmptyDivs } from '../utils';
    import MenuItem from './MenuItem.vue';
    import PanelHeader from './PanelHeader.vue';

    export default {
        components: {
            MenuItem,
            PanelHeader,
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Selected design side.
             */
            selectedDesignSide() {
                return this.$store.state.customizer.designSide;
            },
            /**
             * Selected design side description.
             */
            selectedDesignSideDescription() {
                const side = (this.selectedDesignSide || '').toUpperCase().replace('-', '');

                return this.$t(`DESIGN_SIDE_${side}_DESCRIPTION`);
            },
        },
        mounted() {
            // When the component is loaded, capture the current state of the view controller and save it in case
            // we need to revert to the previous state and toss away all customizations.
            //
            // At any given time there should be only one module that can do the revert.
            this.captureController();
            fillEmptyDivs();
        },
        methods: {
            /**
             * Captures the current state and active controller so we could cancel changes if necessary.
             */
            captureController() {
                if (this.viewController) {
                    this.revertDesignSide = this.selectedDesignSide;
                }
            },

            /**
             * Accept color choice.
             */
            accept() {
                // Keep the current configured view controller, and go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Reject color changes and restore the original selection.
             */
            cancel() {
                // Revert back to the state of the controller as was captured when the component was mounted.
                this.$store.dispatch('setDesignSide', this.revertDesignSide);

                // Go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Sets design side.
             */
            selectSide(side) {
                this.$store.dispatch('setDesignSide', side);
            },
        },
    };
</script>
